<template>
	<div class="responsive-note">
		<h3 class="mt-12 font-weight-black">Buscar Url</h3>
		<v-card class="mt-5 d-flex align-start" width="1219" height="172">
			<div class="rounded borderGreen" style="height: 163px; width: 3px !important; background-color: var(--green); margin: 5px"></div>
			<div class="">
				<v-radio-group class="mt-6 pl-10" row v-model="channel">
					<v-radio class="mr-1" type="radio" :value="shorter" /><label class="">Url Curta</label>
					<v-radio class="ml-10 mr-1" type="radio" :value="longer" />Url Longa
				</v-radio-group>
				<span class="font-weight-black pt-0 pl-10 d-flex flex-column" style="font-size: 14px">Url</span>
				<span class="d-flex align-center">
					<input
						placeholder="Insire a URL longa aqui."
						v-model="url"
						class="mt-3 pl-2 responsive-input-long" 
						style="border: 2px solid var(--grey-day-020); height: 48px; width: 900px; margin-left: 40px; margin-right: 20px; border-radius: 4px"
					>
					<v-btn
						width="226"
						height="48"
						class="mt-2"
						:disabled="url === ''"
						:style="
							url !== '' ? 'background: var(--red); color: var(--white)' : 'background: var(--white); color: var(--black)'"
						@click="getUrl"
					>
						<img :src="url === '' ? '../../../../static/images/search_grey.svg' : '../../../../static/images/search.svg'"/>
						<span class="pl-3 ff">Buscar Url</span>
					</v-btn>
				</span>
			</div>
		</v-card>

		<h3 v-if="openResponse" class="mt-12 font-weight-black">Resultado</h3>
		<transition name="slide">
			<v-card v-if="openResponse" class="mt-5 d-flex align-start" width="1219" height="550">
				<div class="rounded borderGreen" style="height: 540px; width: 3px !important; background-color: var(--blue); margin: 5px"></div>
				<div class="">
					<span class="font-weight-black pt-7 pl-10 d-flex flex-column" style="font-size: 14px">Url curta</span>
					<span class="d-flex align-center">
						<span
							class="mt-3 d-flex align-center pa-5 responsive-input-short-reports rounded"
							style="border: 2px solid var(--grey-day-020); height: 48px; width: 975px; margin-left: 40px; margin-right: 20px; background: var(--grey-day-020)"
						>{{urlData.shortUrl}}</span>
					</span>
					<span class="font-weight-black pt-6 pl-10 d-flex flex-column" style="font-size: 14px">Url destino</span>
					<span class="d-flex align-center">
						<input
							v-model="urlData.longUrl"
							class="mt-3 d-flex align-center pa-5 responsive-input-short-reports"
							style="border: 2px solid var(--grey-day-020); height: 48px; width: 975px; margin-left: 40px; margin-right: 20px; border-radius: 4px; background: var(--grey-day-020); word-break: break-all"
						/>
					</span>
					<span class="font-weight-black pt-6 pl-10 d-flex flex-column" style="font-size: 14px">Criada em:</span>
					<span class="d-flex align-center">
						<span
							class="mt-3 d-flex align-center pa-5 responsive-input-short-reports"
							style="border: 2px solid var(--grey-day-020); height: 48px; width: 975px; margin-left: 40px; margin-right: 20px; border-radius: 4px; background: var(--grey-day-020)"
						>{{formatDate(urlData.createdAt)}}</span>
					</span>
					<span class="font-weight-black pt-6 pl-10 d-flex flex-column" style="font-size: 14px">Cliques</span>
					<span class="d-flex align-center">
						<span
							class="mt-3 d-flex align-center pa-5 responsive-input-short-reports"
							style="border: 2px solid var(--grey-day-020); height: 48px; width: 975px; margin-left: 40px; margin-right: 20px; border-radius: 4px; background: var(--grey-day-020)"
						>
						{{urlData.totalClick}}</span>
					</span>
					<v-btn
						width="226"
						height="48"
						class="mt-12 ml-10 mb-5"
						:disabled="!urlHistory"
						style="background: var(--red); color: var(--white)"
						@click="history"
					>
						<img :src="!urlHistory ? '../../../../static/images/search_grey.svg' : '../../../../static/images/search.svg'"/>
						<span class="pl-3 ff">Histórico de Edição</span>
					</v-btn>
				</div>
			</v-card>
		</transition>

		<v-navigation-drawer
      v-model="drawer"
      fixed
      overlay
      temporary
      right
      width="900"
      height="100vh"
      style="background: var(--grey-day-010)"
    >
      <ReportsHistory @close="drawer = false" :reports="historyInfo" />
    </v-navigation-drawer>

		<div style="height: 100px"></div>
	</div>
</template>
<script>
// Components
import ReportsHistory from './ReportsHistory.vue'

// Lib
import { mapState, mapActions, mapMutations } from 'vuex'
import VueCookies from 'vue-cookies'

//mixins
import date from '../../../mixins/date'

export default {
	mixins: [date],
	components: {
		ReportsHistory
	},
	data () {
		return {
			url: '',
			openResponse: false,
			channel: 'longer',
			shorter: 'shorter',
			longer: 'longer',
			drawer: false,
			historyInfo: null,
			hasHistory: false
		}
	},
	computed: {
		...mapState('UrlTools', {
			urlData: 'url',
			urlHistory: 'urlHistory'
		}),
	},
	methods: {
		...mapActions('UrlTools',{
			getUrlShort: 'getUrlShort',
			getUrlLongReport: 'getUrlLongReport',
			getHistoryUrlShort: 'getHistoryUrlShort'
		}),
		...mapMutations('UrlTools', {
			setUrl: 'SET_URL',
		}),
		...mapMutations('Shared', {
      setToaster: 'SET_TOASTER'
    }),
		async getUrl () {
			const token = VueCookies.get('jwt-login')
			const urlFormat = this.url.toString()
			this.setUrl(urlFormat)
			try {
				const urlLongWhiteSpace = this.url.split(' ')
				if (urlLongWhiteSpace.length > 1) {
					this.toaster(
						'URL contém espaço em branco',
						'var(--red)',
						true
					)
					return 
				} else {
					if (this.channel === 'shorter') {
						const response = await this.getUrlShort({token})
						if (response.status >= 400) {
							throw new Error(response.data.message)
						} else {
							this.openResponse = true
						}
					} else {
						const response = await this.getUrlLongReport({token})
						if (response.status >= 400) {
							throw new Error(response.data.message)
						} else {
							this.openResponse = true
						}
					}
					this.getHistoryUrl()
					this.historyInfo = this.urlHistory
				}
			} catch (e) {
	
        this.toaster(
					'URL não econtrada',
					'var(--red)',
					true
				)
      }
		},
		history () {
			this.getHistoryUrl()
			this.drawer = true
		},
		async getHistoryUrl () {
			const token = VueCookies.get('jwt-login')
			try {
				await this.getHistoryUrlShort({
					shortUrl: this.urlData.shortUrl,
					token
				})
				this.historyInfo = this.urlHistory
			} catch (e) {
        this.toaster(
					'URL não econtrada',
					'var(--red)',
					true
				)
      }
		},
		toaster(message, color, visible) {
      this.setToaster({
        message,
        color,
        visible
      })
    },
	},
	watch: {
		'url' () {
			this.openResponse = false
		},
		'urlHistory' () {
			this.hasHistory
		}
	}
}
</script>
<style lang="">
.responsive-input-short-reports {
	width: 1119px !important;
}
@media screen and (max-width: 1377px) {
	.responsive-note {
		width: 817px
	}
	
	.borderGreen {
		padding-left: 4px;	
	}
	.responsive-input-long {
		width: 500px !important;
	}
	.responsive-input-short-reports {
		width: 715px !important;
	}
}

</style>


// WEBPACK FOOTER //
// src/components/Contents/UrlTools/ReportTools.vue